import { createFileRoute } from '@tanstack/react-router';

import { ClassEnrollmentsPage } from '~features/classes/ui/class-enrollments';

const Component = () => {
  const { classId } = Route.useParams();
  return <ClassEnrollmentsPage classId={classId} />;
};

export const Route = createFileRoute(
  '/_auth/_layout/classes/$classId/enrolled-students',
)({
  component: Component,
});
